var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTagGroup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-tag-group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-204.000000, -104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-tag-group",
    transform: "translate(204.000000, 104.800000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -1.42108547e-14,
    y: 0.2,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7220919,17.0381244 L12.7220919,17.8332552 L11.1318304,17.8332552 L11.1318304,17.0381244 C11.1318304,14.4032929 8.99587747,12.2673399 6.36104596,12.2673399 C3.72621445,12.2673399 1.59026149,14.4032929 1.59026149,17.0381244 L1.59026149,17.8332552 L0,17.8332552 L0,17.0381244 C0,13.5250157 2.84793728,10.6770784 6.36104596,10.6770784 C9.87415464,10.6770784 12.7220919,13.5250157 12.7220919,17.0381244 Z",
    id: "Path",
    fill: "#777777",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36104596,8.60973851 C7.590634,8.60973851 8.58741205,7.61296046 8.58741205,6.38337242 C8.58741205,5.15378439 7.590634,4.15700634 6.36104596,4.15700634 C5.13145793,4.15700634 4.13467988,5.15378439 4.13467988,6.38337242 C4.13467988,7.61296046 5.13145793,8.60973851 6.36104596,8.60973851 Z M6.36104596,10.2 C4.25318076,10.2 2.54441838,8.49123763 2.54441838,6.38337242 C2.54441838,4.27550722 4.25318076,2.56674485 6.36104596,2.56674485 C8.46891117,2.56674485 10.1776735,4.27550722 10.1776735,6.38337242 C10.1776735,8.49123763 8.46891117,10.2 6.36104596,10.2 Z",
    id: "Oval",
    fill: "#777777",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,15.2952895 L20,15.9946601 L18.6012588,15.9946601 L18.6012588,15.2952895 C18.6012588,12.9777793 16.7225456,11.099066 14.4050353,11.099066 C12.7956248,11.099066 11.3978329,12.0051133 10.6939103,13.3349572 C10.3842023,13.9200547 9.07022979,13.3644152 9.52628888,12.5543824 C10.4853755,10.8508936 12.3108405,9.70032484 14.4050353,9.70032484 C17.495049,9.70032484 20,12.2052759 20,15.2952895 Z",
    id: "Path",
    fill: "#777777",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4050353,7.88196131 C15.4865401,7.88196131 16.3632729,7.00522845 16.3632729,5.92372366 C16.3632729,4.84221888 15.4865401,3.96548602 14.4050353,3.96548602 C13.3235305,3.96548602 12.4467977,4.84221888 12.4467977,5.92372366 C12.4467977,7.00522845 13.3235305,7.88196131 14.4050353,7.88196131 Z M14.4050353,9.28070248 C12.5510271,9.28070248 11.0480565,7.77773187 11.0480565,5.92372366 C11.0480565,4.06971546 12.5510271,2.56674485 14.4050353,2.56674485 C16.2590435,2.56674485 17.7620141,4.06971546 17.7620141,5.92372366 C17.7620141,7.77773187 16.2590435,9.28070248 14.4050353,9.28070248 Z",
    id: "Oval",
    fill: "#777777",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTagGroup);
export default __webpack_public_path__ + "static/media/ic-tag-group.eb7bf174858e5ecfc0b201b5d00542d7.svg";
export { ForwardRef as ReactComponent };